/**
* this is the portfolio component that includes the empty state
* the loader state and the bar chart
*
* Created by Tom on 12/06/18
*/

import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import cx from 'classnames'
import {BarChart} from 'react-easy-chart';
import moment from 'moment'
import config from '../../config'
import { intlNumberFormatter } from '../../utility/utilities'

// action import
import { ActionCreator } from '../../actions/'

// style import
import './style.scss'


class Portfolio extends Component {

    constructor(props) {
        super(props)
        this.state = {
            effectiveWidth: 0,
            wrapperWidth: 0,
            effectiveHeight: 250,
            showToolTip: false,
            top: `0px`,
            left: `0px`,
            y: "",
            x:"",
            toolTipText:"",
            helptextStyle: {},
            openRightMenu:true,
        }
        this._reCalcualtingGraphSize = this._reCalcualtingGraphSize.bind(this);
    }

    componentDidMount() {
        window.addEventListener("resize", this._reCalcualtingGraphSize, false)
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this._reCalcualtingGraphSize, false)
    }

    componentDidUpdate(prevProps, prevState) {

        const { effectiveWidth, effectiveHeight } = this.state
        const { openRightMenu, pLoading } = this.props

        // setTimeout(() => {
        if(pLoading == false){
          if(prevProps.openRightMenu !== openRightMenu || (prevState.effectiveWidth !== effectiveWidth) || (effectiveWidth === 0))
              this._calcualtingGraphSize(openRightMenu)
        }
      }

    _reCalcualtingGraphSize(){

          const { openRightMenu } = this.state
          this._calcualtingGraphSize(openRightMenu)
    }

    _calcualtingGraphSize(openRightMenu){

        //Note: calculation need to consider if leftmenu open, size of screen, size of dashboard box

        setTimeout(() => {
          const width = document.getElementsByClassName("dashboard__display-box")[0].offsetWidth
          const height = document.getElementsByClassName("dashboard__display-box")[0].offsetHeight
          const screenSize = document.getElementById('root').offsetWidth;
          this.setState({openRightMenu: openRightMenu})

          if(openRightMenu == true){ //if rightmenu open
            if(screenSize <= 1800) { //if smaller than  extra large breakpoint so can't have 2/row
              if( (width-60) > 800)
                this.setState({effectiveWidth: (width - 60), effectiveHeight: height - 135, wrapperWidth: (width - 60)})
              else
                this.setState({effectiveWidth: 800,effectiveHeight: 290, wrapperWidth: (width)})
            }

            else{
              if( (width-60) > 800)
                this.setState({effectiveWidth: (width - 60), effectiveHeight: height - 135, wrapperWidth: (width)})
              else
                this.setState({effectiveWidth: 800, effectiveHeight: 290, wrapperWidth: (width)})
            }
          }else{ //if rightmenu close
            if(screenSize <= 1300){
              if( (width-60) > 800)
                this.setState({effectiveWidth: (width - 60), effectiveHeight: height - 135, wrapperWidth: (width)})
              else
                this.setState({effectiveWidth: 800,effectiveHeight: 290, wrapperWidth: (width)})
            } //switch to tablet size
            else{
              if( (width-60) > 800)
                this.setState({effectiveWidth: (width - 60), effectiveHeight: height - 135, wrapperWidth: (width)})
              else
                this.setState({effectiveWidth: 800, effectiveHeight: 290, wrapperWidth: (width)})
            }

          }

      }, 50)
    }

    // Mouse handler for graph helptext when hover
    _mouseOverHandler(d, e) {
      ::this.setState({showToolTip: true,
          top: `${e.clientY - 140}px`,
          left: `${e.clientX - 340}px`,
          y: d.y,
          x: d.x});

    }

    _mouseMoveHandler(e) {

      if (this.state.showToolTip) {
        ::this.setState({
            top: `${e.clientY - 140}px`,
            left: `${e.clientX - 340}px`,
            toolTipText:this.state.x + " " + intlNumberFormatter('en-AU', 'currency', 'AUD', this.state.y)
        });

      }
    }

    _mouseOutHandler() {
      ::this.setState({
          showToolTip: false,
          toolTipText:""
      });

    }

    render() {
        const { pData, pFundValue, openRightMenu } = this.props
        const { effectiveWidth, effectiveHeight, toolTipText, left, top, showToolTip, wrapperWidth } = this.state
        const todayDate = moment().format("YYYY-MM-DD"),
              startDate = moment().subtract(6, 'months').format("D-MMM-YY"),
              fundValue = intlNumberFormatter('en-AU', 'currency', 'AUD', pFundValue),
              downloadURL = config.endpoints.portfolioDownloadURL + todayDate

        let pGraphData = []
        let smallestValue, largestValue = 0
        let endDate = moment().add(14, 'days').format("D-MMM-YY")  //Added additional 14 days to create gap for the last entries

        for (var i in pData) {
            var day = moment(pData[i].date_created).day();

            if(day == 1){ //determine if is monday
                pGraphData.push({
                    x: moment(pData[i].date_created).format("D-MMM-YY"),
                    y: pData[i].fund_value,
                    color: '#4538d1'
                })
            }


            if(i == 0){
                smallestValue =  pData[i].fund_value
                largestValue =  pData[i].fund_value
            }else{
                if(pData[i].fund_value < smallestValue){
                    smallestValue =  pData[i].fund_value
                }
                if(pData[i].fund_value > largestValue){
                    largestValue =  pData[i].fund_value
                }
            }
        }

        // If the data returned contain a Monday or empty
        if(pGraphData.length <= 1 &&  pFundValue > 0 ){
            smallestValue = 0
            largestValue = pFundValue

            // If the data returned does not contain a Monday(empty), then display the today's data.
            if(pGraphData.length === 0){
                pGraphData.push({
                    x: moment().format("D-MMM-YY"),
                    y: pFundValue,
                    color: '#4538d1'
                })
            }
        }

        const lastValue= pGraphData[pGraphData.length - 1]

        // graph need to be render in x axies order else console would throw errors
         pGraphData.sort((a, b) => a.x - b.x);

        //need to set the range value for graph
        const range = largestValue - smallestValue;
        const endRange = largestValue + (range * 0.5);
        const isIE = /*@cc_on!@*/false || !!document.documentMode;
        const isEdge = !isIE && !!window.StyleMedia;
        let startRange = smallestValue - (range * 0.5);

        if(startRange < 0){
            startRange = 0;
        }

        return (
            <div className="portfolio">

                {/* header container*/}
                <div className="portfolio__header">

                    <div className="portfolio__header__title">
                        <p>WHAT IS MY PORTFOLIO WORTH??</p>
                    </div>
                    <div className="portfolio__header__investment-valuation">
                        <p className="portfolio__header__investment-valuation__total">
                            VALUE &nbsp;&nbsp;&nbsp;{ fundValue }
                        </p>

                        <a href={ downloadURL } target="_blank" className="portfolio__header__investment-valuation__button">
                            Investment valuation
                        </a>
                    </div>

                </div>

                {/* https://github.com/rma-consulting/react-easy-chart */}
                <div className="portfolio__data__graph-legend">
                    <p><span className="portfolio__data__graph-legend__box"></span>FUND VALUE ($)</p>
                </div>
                <div className={"portfolio__data__graph "+(isEdge ? 'is_edge' : '')}>
                    <div className="portfolio__data__graph__wrapper" style={ {width:wrapperWidth - 60} }>
                        <BarChart
                            axisLabels={{x: 'Months', y: 'Value'}}
                            yAxisOrientRight
                            axes
                            grid
                            xTickNumber={ 5 }
                            barWidth={ 8 }
                            height={ effectiveHeight }
                            width={ effectiveWidth }
                            margin={ {top: 0, right: -80, bottom: 20, left: 100} }
                            xType={ 'time' }
                            data={ pGraphData }
                            mouseOverHandler={ ::this._mouseOverHandler }
                            mouseOutHandler={ ::this._mouseOutHandler }
                            mouseMoveHandler={ ::this._mouseMoveHandler }
                            xDomainRange={ [startDate, endDate] }
                            yDomainRange={ [startRange, endRange] }
                        />
                    </div>
                    <div style={ {left:left, top:top} } className={"portfolio__data__graph__helptext "+(showToolTip ? 'show' : 'hidden')}>
                        { toolTipText }
                    </div>
                </div>
            </div>
        )
    }
}

// define the prop types
Portfolio.propTypes = {
    pData: PropTypes.array,
    pFundValue: PropTypes.number, // although it's a FLOAT
}

// pull props to this container
const mapStateToProps = (state) => {
    return {
        pFundValue: state.portfolioState.pFundValue,
        pData: state.portfolioState.pData,
        pLoading: state.portfolioState.pLoading,
        openRightMenu: state.componentState.openRightMenu,
    }
}

// pull all required action creators into this container
const mapDispatchToProps = (dispatch) => {
    const action = bindActionCreators(ActionCreator, dispatch)
    return {
        getPortfolioData: action.getPortfolioData,
        setOpenRightMenu: action.setOpenRightMenu
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Portfolio)



// WEBPACK FOOTER //
// ./src/components/Portfolio/index.js